import { Form, Tooltip, Typography } from 'antd'
import useEraseTripod from 'pages/building/tourViewerPage/hook/Extra/useEraseTripod'
import Validators from 'utils/validators'

import Button from 'components/atoms/Button'
import ImageHelper from 'components/atoms/ImageHelper'
import Modal from 'components/atoms/Modal'
import Spinner from 'components/atoms/Spinner'
import Title from 'components/atoms/Title'

export default function ModalSettingBusiness({
  handleCancel
}: {
  handleCancel: () => void
}) {
  const {
    t,
    form,
    inputRef,
    tripodImage,
    handleSaveTripod,
    handleChooseFile,
    handleFileChange,
    handleDeleteTripod,
    selectedFile,
    isLoading,
    updating,
    deleting
  } = useEraseTripod({ handleCancel })

  return (
    <Modal className="modal-custom" width={700} destroyOnClose>
      <Title title={t('building.easerTripod.title')} bottomMargin="mb-[31px]" />

      <Form form={form} colon={false} onFinish={handleSaveTripod}>
        <Spinner spinning={isLoading || updating || deleting}>
          {/* Image */}
          <div>
            {/* Image */}
            <div className="flex justify-between items-center gap-x-4">
              <Typography.Text className="font-bold">
                {t('building.easerTripod.image_title')}
              </Typography.Text>

              {/* div show image selected  */}
              <Form.Item
                name="tripodImageWrapper"
                dependencies={['tripodImage']}
                hasFeedback
                className="logo-upload !mb-0"
                style={{ flex: 1, minWidth: 0 }}
              >
                <div
                  onClick={handleChooseFile}
                  className="ml-4 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center"
                >
                  {selectedFile ? (
                    <Tooltip
                      title={selectedFile?.name || t('building.noImageNote')}
                      placement="topLeft"
                    >
                      <Typography.Text className="truncate text-center w-full ">
                        {selectedFile?.name}
                      </Typography.Text>
                    </Tooltip>
                  ) : (
                    <Typography.Text className="text-center w-full ">
                      {t('building.noImageNote')}
                    </Typography.Text>
                  )}
                </div>
              </Form.Item>

              <div className="flex flex-col gap-y-[2px] items-center mt-10">
                <div>
                  <div className="flex flex-col justify-center items-center">
                    <Typography
                      onClick={handleChooseFile}
                      className="bg-[#B3CFCB] mt-2 p-2 w-12 rounded-[10px] cursor-pointer hover:opacity-80"
                    >
                      {t('building.chooseLogoFileBtn')}
                    </Typography>
                    <div className="text-[10px] font-[400px] pt-2">
                      {t('building.fileSizeNote')}
                    </div>
                  </div>

                  <Form.Item
                    name="tripodImage"
                    className="mb-0"
                    rules={[
                      {
                        validator: Validators.validateFileSize(t, 50)
                      }
                    ]}
                  >
                    <div className="hidden" />
                  </Form.Item>

                  <input
                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                    type="file"
                    ref={inputRef}
                    onChange={handleFileChange}
                    hidden
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Image Preview */}
          <Typography.Text className="text-sm font-[400px]">
            {t('building.easerTripod.note')}
          </Typography.Text>
          <div className="relative w-full h-[236px] mt-4 flex items-center justify-center">
            {tripodImage && (
              <div className="relative z-10">
                <ImageHelper
                  wrapperClassName=""
                  src={tripodImage}
                  alt="tripodImage"
                  loading="lazy"
                  width={400}
                  height={200}
                  className="object-contain"
                />
              </div>
            )}
          </div>
        </Spinner>

        {/* Action area */}
        <div className="flex gap-10 justify-center mt-10">
          {/* Button delete */}
          <Button
            onClick={handleDeleteTripod}
            sizing="w-[140px] h-[50px]"
            className="bg-[#B80808]"
          >
            {t('common.delete')}
          </Button>
          {/* Button cancel */}
          <Button sizing="w-[140px] h-[50px]" onClick={handleCancel}>
            {t('building.buttonCancel')}
          </Button>
          {/* Button save */}
          <Button
            disabled={!selectedFile && !tripodImage}
            htmlType="submit"
            type="primary"
            sizing="w-[140px] h-[50px]"
          >
            {!selectedFile && tripodImage
              ? t('building.buttonDownload')
              : t('building.buttonSave')}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}
